import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from 'src/app/components/material/material.module';
import { CoreModule } from 'src/app/core/core.module';
import { AccountingComponent } from './accounting.component';
import { BatchExportComponent } from './batch-export/batch-export.component';
import { BatchDetailsComponent } from './batch-details/batch-details.component';
import { MatIconRegistry } from '@angular/material/icon';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PartialsModule } from '../../partials/partials.module';
import { CodePreviewModule } from '../../partials/content/general/code-preview/code-preview.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from 'src/app/core/_config/missingTranslationHandler';
import { RouterModule, Routes } from '@angular/router';
import { AccountingAttachmentComponent } from './batch-details/accounting-attachments/accounting-attachment/accounting-attachment.component';

const routes: Routes = [
    {
        path: '',
        component: AccountingComponent,
        children: [
            {
                path: 'batch',
                component: BatchExportComponent,
            },
            {
                path: 'batch-details/:id',
                component: BatchDetailsComponent,
            },
        ],
    },
];

@NgModule({
    declarations: [AccountingComponent, BatchExportComponent, BatchDetailsComponent, AccountingAttachmentComponent],
    imports: [
        NgbModule,
        TranslateModule.forChild({
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
            useDefaultLang: false,
        }),
        CommonModule,
        NgSelectModule,
        CoreModule,
        PartialsModule,
        CodePreviewModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentsModule,
        TextMaskModule,
        NgbAlertModule,
        MaterialModule,
        MatMomentDateModule,
        RouterModule.forChild(routes),
    ],
    exports: [RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        MatIconRegistry,
        { provide: MatBottomSheetRef, useValue: {} },
        { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
        DatePipe,
    ],
})
export class AccountingModule {}
